import { StyleSheet, View } from 'react-native'

import { translate } from '../../../i18n'
import { color, fontFamily } from '../../../theme'
import { DS } from '../../../design-system'
import { GameModal } from './GameModalContainer'

interface SittingOutModalProps {
  visible: boolean
  onReturn: () => void
  onLeave: () => void
}

export const SittingOutModal: React.FC<SittingOutModalProps> = ({ visible, onReturn, onLeave }) => {
  return (
    <GameModal visible={visible} onClose={() => {}}>
      <View style={styles.modalContainer}>
        <View style={styles.container}>
          <DS.Text variant="Heading 2/Medium" textAlign="center">
            {translate('gameScreen.sittingOutModal.title')}
          </DS.Text>
          <DS.Text variant="Body Small/Regular" textAlign="center">
            {translate('gameScreen.sittingOutModal.message')}
          </DS.Text>
          <DS.Frame gap="8" justifyContent="center" alignItems="center">
            <DS.Button onPress={onReturn} variant="Medium/Primary" type="On Light" style={styles.button}>
              {translate('gameScreen.sittingOutModal.returnToGame')}
            </DS.Button>
            <DS.Button onPress={onLeave} variant="Medium/Secondary" type="On Dark" style={styles.button}>
              {translate('gameScreen.sittingOutModal.leaveGame')}
            </DS.Button>
          </DS.Frame>
        </View>
      </View>
    </GameModal>
  )
}

const styles = StyleSheet.create({
  modalContainer: {
    backgroundColor: color.palette.cream,
    alignItems: 'center',
    marginHorizontal: 24,
    paddingHorizontal: 24,
    borderRadius: 20
  },
  container: {
    width: '100%',
    paddingVertical: 24,
    gap: 20
  },
  button: {
    width: '100%'
  },
  buttonTitleStyle: {
    fontFamily: fontFamily.GTAmericaStandardMedium,
    fontSize: 16,
    paddingVertical: 5
  }
})
